export function replacementExecutionImmutableFieldsMatch(left, right) {
    return (left.replacement_id === right.replacement_id &&
        left.local_profile_id === right.local_profile_id &&
        left.execution_scope === right.execution_scope &&
        left.connectivity === right.connectivity &&
        left.account_identity_sha256 === right.account_identity_sha256 &&
        left.source_database_name === right.source_database_name &&
        left.source_generation === right.source_generation &&
        left.predecessor_epoch === right.predecessor_epoch &&
        left.replacement_epoch === right.replacement_epoch &&
        left.restore_checkpoint_id === right.restore_checkpoint_id &&
        left.restore_checkpoint_kind === right.restore_checkpoint_kind &&
        left.restore_checkpoint_payload_sha256 === right.restore_checkpoint_payload_sha256 &&
        left.invalidate_previous_outbox === right.invalidate_previous_outbox &&
        left.force_other_devices_full_resync === right.force_other_devices_full_resync &&
        left.before_snapshot_sha256 === right.before_snapshot_sha256 &&
        left.replacement_payload_sha256 === right.replacement_payload_sha256 &&
        left.prepared_at === right.prepared_at);
}
export function replacementExecutionRowsMatch(left, right) {
    return (replacementExecutionImmutableFieldsMatch(left, right) &&
        left.applied_at === right.applied_at &&
        left.status === right.status);
}
//# sourceMappingURL=replacement-execution.js.map